module.exports = {
  MultipleAnswer: {
    PluginName: "Selección Múltiple",
    content_box_name: "Contenedor  ",
    Statement:
      "Esta es una pregunta con varias opciones para responder. Puede haber más de una respuesta correcta. Puedes escribir aquí el enunciado de la pregunta",
    Question: "Pregunta",
    Feedback: "Explicación",
    FeedbackMsg:
      "Aquí puedes incluir una explicación acerca de la respuesta. Puedes desactivar esta opción en la barra de herramientas.",
    TrueFeedbackMsg:
      "Aquí puedes añadir una explicación sobre la respuesta correcta. Puedes desactivar esta opción en la barra de herramientas.",
    FalseFeedbackMsg:
      "Aquí puedes añadir una explicación sobre la respuesta incorrecta. Puedes desactivar esta opción en la barra de herramientas.",
    ShowFeedback: "Mostrar explicación",
    Answer: "Respuesta",
    Number: "Número de respuestas",
    ShowLettersInsteadOfNumbers: "Numeración",
    ShowLetters: "Letras",
    ShowNumbers: "Números",
    AllowPartialScore: "Permitir aciertos parciales",
    Color: "Color",
    correctAnswerFeedback: "Respuesta correcta",
    None: "Ninguna",
    notCount: "Este ejercicio no añade puntos a la nota",
    CheckAnswerText: "Texto del Botón Verificar Respuesta",
    TryAgainText: "Texto del Botón Intentar de Nuevo",
    SeeAnswerText: "Texto del Botón Ver Respuesta",
    ButtonStyle: "Estilo del Botón",
    ButtonBackground: "Color de Fondo del Botón",
    ButtonTextColor: "Color de Texto del Botón",
    ButtonBorderColor: "Color de Borde del Botón",
    ButtonBorderWidth: "Grosor del Borde del Botón",
    ButtonBorderRadius: "Radio de Borde del Botón",
    ButtonPadding: "Espaciado del Botón",
    ButtonFontSize: "Tamaño de Fuente del Botón",
    ButtonFontWeight: "Peso de Fuente del Botón",
    ButtonHoverBackground: "Color de Fondo al Pasar el Ratón",
    tryAgain: "Inténtalo de nuevo",
    checkAnswer: "Comprueba la respuesta",
  },
};
